// Add one entry per product. Leave salesUrl empty until the real sales page link is confirmed.
export const products = [
  {
    id: 'atletismo-360',
    name: 'Atletismo 360',
    audience: 'For track & field coaches',
    language: 'Spanish',
    format: 'Digital guides',
    description:
      'A complete training system for athletics coaches, with ready-to-use sessions and exercises covering sprints, hurdles, jumps, throws, distance, and race walking.',
    highlights: [
      { value: '6', label: 'Technical volumes' },
      { value: '70+', label: 'Ready sessions' },
      { value: '5', label: 'Bonus guides' },
    ],
    image: 'https://cdn.magicpatterns.com/uploads/u8FyQAMTwNXDrSFyFf3EEz/ChatGPT_Image_17_sept_2026,_23_38_09.png',
    salesUrl: 'https://atletismo360.tupuntodigital.shop/',
  },
  {
    id: 'atletica-360',
    name: 'Atletica 360',
    audience: 'For track & field coaches',
    language: 'Italian',
    format: 'PDF',
    description:
      'The complete digital system for athletics coaches in Italian, with ready-to-use sessions and exercises to plan the full training season.',
    highlights: [
      { value: '6', label: 'Technical volumes' },
      { value: '70+', label: 'Ready sessions' },
      { value: '5', label: 'Bonus guides' },
    ],
    image: 'https://cdn.magicpatterns.com/uploads/5buu7WL7zwyanPuZ5pm83U/Imagen_de_ChatGPT_27_sept_2026,_00_29_47.png',
    salesUrl: 'https://atletica360.tupuntodigital.shop/',
  },
];
